import { render, staticRenderFns } from "./ReceiverListAddNew.vue?vue&type=template&id=33bdcd72"
import script from "./ReceiverListAddNew.vue?vue&type=script&lang=js"
export * from "./ReceiverListAddNew.vue?vue&type=script&lang=js"
import style0 from "./ReceiverListAddNew.vue?vue&type=style&index=0&id=33bdcd72&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports